export default __webpack_public_path__ + "static/media/texture-cropped.1a3e1cdb.png";